import { Typography } from 'antd';
import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import type { NCalendars } from '@app/components/Calendars/types';
import { useOutsideClick } from '@app/hooks';
import '@app/components/Calendars/components/MonthGrid/components/TaskPopover/Popover.desktop.scss';

const { Text } = Typography;

export const TaskPopover: React.FC<{
  extraTaskList: NCalendars.UpdateTaskInterface[];
  width: number;
  onClick: (id: number) => void;
  position?: 'top' | 'bottom';
}> = ({ extraTaskList, width, onClick, position = 'bottom' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const popoverRef = useRef<HTMLDivElement | null>(null);

  useOutsideClick(buttonRef, () => setIsOpen(false));

  const handleToggle = () => setIsOpen((prev) => !prev);

  const top =
    position === 'bottom'
      ? buttonRef.current?.getBoundingClientRect().bottom
      : undefined;
  const bottom =
    position === 'top' && buttonRef.current
      ? window.innerHeight - buttonRef.current?.getBoundingClientRect().top
      : undefined;
  const left = buttonRef.current?.getBoundingClientRect().left;
  const popoverContent = (
    <div
      className={`${CV_PREFIX}-extra-tasks-content-wrapper`}
      style={{
        top,
        bottom,
        left,
        width,
        opacity: isOpen ? 1 : 0,
        visibility: isOpen ? 'visible' : 'hidden',
        transform: isOpen
          ? 'translateY(0)'
          : `translateY(${position === 'top' ? 20 : -20}px)`,
      }}
    >
      <div ref={popoverRef} className={`${CV_PREFIX}-extra-tasks-content`}>
        {extraTaskList.map(({ id, title, status }) => (
          <div
            key={id}
            className={`${CV_PREFIX}-monthly-extra-task`}
            data-status={status}
            onClick={() => onClick(+id)}
          >
            {title}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div
      ref={buttonRef}
      className={`${CV_PREFIX}-extra-tasks`}
      onClick={handleToggle}
    >
      <Text style={{ width }}>Еще {extraTaskList.length}</Text>
      {popoverContent && ReactDOM.createPortal(popoverContent, document.body)}
    </div>
  );
};
